((root, factory) => {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  root.CorkopiaGlobalShell = api;
  if (typeof document !== 'undefined') api.init(document, root);
})(typeof globalThis !== 'undefined' ? globalThis : window, () => {
  'use strict';

  const shouldCompact = (scrollY) => Number(scrollY) > 24;

  const init = (documentRef, windowRef) => {
    const header = documentRef.querySelector('[data-global-header]');
    let frame = 0;
    const updateHeader = () => {
      if (!header) return;
      header.toggleAttribute('data-compact', shouldCompact(windowRef.scrollY));
      frame = 0;
    };
    const requestHeaderUpdate = () => {
      if (frame) return;
      frame = windowRef.requestAnimationFrame(updateHeader);
    };

    updateHeader();
    windowRef.addEventListener('scroll', requestHeaderUpdate, { passive: true });

    // Header over the hero. `data-compact` flips after 24px, which is right for a
    // paper bar gaining a rule and much too early for a bar that has to stay
    // legible over a full-height photograph. This tracks the hero's own bottom
    // edge instead, via a sentinel the section places there.
    //
    // The bottom root margin is extended by a viewport so the sentinel sits well
    // inside the observed band at rest; without it a hero sized near 100vh puts
    // the sentinel exactly on the boundary and the initial state is a coin flip.
    // Only the top edge is doing real work: the header resolves to paper the
    // moment the hero's bottom passes under it.
    const sentinel = documentRef.querySelector('[data-header-overlay-sentinel]');
    if (header && sentinel && 'IntersectionObserver' in windowRef) {
      let overlayObserver = null;
      const watchOverlay = () => {
        overlayObserver?.disconnect();
        overlayObserver = new windowRef.IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            header.toggleAttribute('data-over-hero', entry.isIntersecting);
          });
        }, { rootMargin: `-${header.offsetHeight}px 0px 100% 0px`, threshold: 0 });
        overlayObserver.observe(sentinel);
      };
      watchOverlay();
      // The margin is baked into the observer, so a header that changes height
      // across a breakpoint needs the observer rebuilt rather than just re-read.
      let resizeFrame = 0;
      windowRef.addEventListener('resize', () => {
        if (resizeFrame) return;
        resizeFrame = windowRef.requestAnimationFrame(() => {
          resizeFrame = 0;
          watchOverlay();
        });
      }, { passive: true });
    }

    documentRef.addEventListener('click', (event) => {
      const navigationLink = event.target.closest?.('[data-dialog-dismiss-on-navigate] a');
      if (navigationLink) navigationLink.closest('dialog')?.close();

    });
  };

  return { init, shouldCompact };
});
